export default __webpack_public_path__ + "static/media/씨티.9c41263d.svg";